export const gitex2019 = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'GITEX 2019',
  startDate: '2019-10-06',
  endDate: '2019-10-10',
  location: {
    '@type': 'Place',
    name: 'Dubai World Trade Centre',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Dubai',
      addressCountry: 'AE',
    },
  },
  description:
    'Karolina Kołodziej, CMO at Boldare, spoke with influential tech leaders from the Middle East region at GITEX 2019. Watch a series of video interviews and discover future technology forecasts. Boldare also showcased their work on scaling SaaS platforms like IonoView.',
  organizer: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
  url: 'https://www.boldare.com/gitex-2019/',
};
